/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const CmpPlancard = ({
  weekState,
  className,
  text = "Week 2 • Day 1",
  divClassName,
  text1 = "4 km Easy Run",
}) => {
  return (
    <div className={`cmp-plancard ${className}`}>
      <p className="week-day">{text}</p>

      <div className={`element-km-easy-run ${divClassName}`}>{text1}</div>
    </div>
  );
};

CmpPlancard.propTypes = {
  weekState: PropTypes.oneOf(["current"]),
  text: PropTypes.string,
  text1: PropTypes.string,
};
